import axios from "axios";

export const isSessionActiveCheck = async (sessionId: string | null | undefined) => {
	if (!sessionId) return false;
	if (import.meta.env.MODE === "stembox") return true;
	const resp = await axios.get(
		`https://${import.meta.env.VITE_COLABSERVER_URL}/api/v1/editor-session/`,
		{
			withCredentials: true,
		},
	);

	const activeSessions = resp.data.map((s: any) => s.id);
	if (activeSessions.includes(Number(sessionId))) {
		return true
	} else {
		return false;
	}

};